import { useParams } from 'react-router-dom'
import { Stack, Title } from '@mantine/core'
import { useAuthenticatedGraphQuery } from '@/hooks/use-authenticated-query'
import { SoldWoolSummaryChart } from '@shared/components/wool-data/sold-wool-summary/sold-wool-summary-chart'
import { SoldWoolSummaryTable } from '@shared/components/wool-data/sold-wool-summary/sold-wool-summary-table'
import { getSeasonYear } from '@shared/helpers/get-season-year/get-season-year'
import { GetSoldWoolSummaryGql } from '@/graphql/queries/get-sold-wool-summary.graphql'

export function ClipSummary() {
  // Get the station record number from the URL
  const { stationRecordNumber } = useParams()

  const firstSeason = getSeasonYear(new Date())

  // Get the creditor history data
  const { data, isLoading, isError } = useAuthenticatedGraphQuery({
    queryKey: ['soldWoolSummaryData', stationRecordNumber, firstSeason],
    gql: GetSoldWoolSummaryGql,
    queryParams: {
      stationRecordNumber,
      firstSeason,
    },
    enabled: !!stationRecordNumber && !!firstSeason,
  })

  return (
    <>
      <Stack>
        <Title order={2} data-testid='station-wool-data-clip-summary' mr='auto'>
          Sold Wool Summary
        </Title>

        <SoldWoolSummaryChart data={data?.listSoldWoolSummary?.results} />

        <SoldWoolSummaryTable
          data={data?.listSoldWoolSummary?.results}
          isError={isError}
          isLoading={isLoading}
        />
      </Stack>
    </>
  )
}
